/**
 * Environment configuration utilities
 */

export const env = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '/api/v1',

  // App Configuration
  APP_NAME: import.meta.env.VITE_APP_NAME || 'BuilderBel',
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',

  // Google Maps Configuration
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',

  // Environment
  NODE_ENV: import.meta.env.NODE_ENV || 'development',

  // Environment checks
  isDevelopment: import.meta.env.NODE_ENV === 'development',
  isProduction: import.meta.env.NODE_ENV === 'production',
  isTest: import.meta.env.NODE_ENV === 'test',
} as const;

/**
 * Validates that all required environment variables are present
 */
export const validateEnvironment = (): void => {
  console.group('🔧 Environment Configuration');
  console.log('API Base URL:', env.API_BASE_URL);
  console.log('App Name:', env.APP_NAME);
  console.log('App Version:', env.APP_VERSION);
  console.log(
    'Google Maps API Key:',
    env.GOOGLE_MAPS_API_KEY ? '***configured***' : 'not configured'
  );
  console.log('Environment:', env.NODE_ENV);
  console.log('Is Development:', env.isDevelopment);
  console.groupEnd();

  // Required environment variables
  const requiredVars = ['VITE_API_BASE_URL'];

  const missingVars = requiredVars.filter(
    varName => !import.meta.env[varName as keyof ImportMetaEnv]
  );

  if (missingVars.length > 0) {
    console.error('❌ Missing required environment variables:', missingVars);
    console.error('Please check your .env file and ensure all required variables are set.');
  } else {
    console.log('✅ All required environment variables are configured');
  }
};

/**
 * Gets environment variable with fallback
 */
export const getEnv = (key: keyof ImportMetaEnv, fallback?: string): string => {
  return import.meta.env[key] || fallback || '';
};
